import React, { FC } from 'react';
import { useTranslate } from 'react-admin';
import { SelectInput } from '~/components';
import { statusLabel } from '~/components/StatusField';
import cx from 'classnames';

export const MappingSystemStatusFilter: FC<{
  name: string;
  label?: string;
  value: any;
  onChange: (e: any) => void;
  className?: string;
  [x: string]: any;
}> = (props) => {
  const { name, value, onChange, className, label, ...rest } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.transfers.filters.${key}`);
  return (
    <SelectInput
      label={label || t('ledgerSystemStatus')}
      name={name}
      value={value}
      className={cx(className)}
      options={[
        { value: 'FAILED', text: translate(statusLabel('FAILED')) },
        { value: 'SUBMITTED', text: translate(statusLabel('SUBMITTED')) },
        { value: 'SKIPPED', text: translate(statusLabel('SKIPPED')) },
      ]}
      onChange={onChange}
      {...rest}
    />
  );
};

export default MappingSystemStatusFilter;
